import { FIREBASE_CONFIG } from '@/shared/config/app-config';
import { getApps, initializeApp } from 'firebase/app';
import { type Auth, getAuth } from 'firebase/auth';

let auth: Auth | null = null;

export function isFirebaseConfigured(): boolean {
  return FIREBASE_CONFIG.apiKey.length > 0;
}

/** Lazily initialised Firebase Auth (phone verification only). */
export function getFirebaseAuth(): Auth {
  if (auth) return auth;
  const app =
    getApps()[0] ??
    initializeApp({
      apiKey: FIREBASE_CONFIG.apiKey,
      authDomain: FIREBASE_CONFIG.authDomain || undefined,
      projectId: FIREBASE_CONFIG.projectId || undefined,
    });
  auth = getAuth(app);
  auth.languageCode = 'fr';
  if (FIREBASE_CONFIG.appVerificationDisabledForTesting) {
    auth.settings.appVerificationDisabledForTesting = true;
  }
  return auth;
}
